import { RankingController } from "./Ranking";
import { LeagueService, TeamService, UserService, IRankingEntry, RankingEntry, Swiss, LeagueState, LeagueFactory } from "ng-league";
import { Store } from "@ngrx/store";
import { EntryState, RootState, getLeague, LoadLeagueOnceAction } from "@play/state";
import { League } from "@play/api-typings";
import { IRankingScope } from "./RankingScope";
import { filter } from "rxjs/operators";

export class SwissRankingController extends RankingController {
    public league: Swiss;

    public static $inject = ["$scope", "SettingsService", "LeagueService", "TeamService", "UserService", "store"];
    constructor(
        protected $scope: IRankingScope,
        protected SettingsService,
        protected LeagueService: LeagueService,
        protected TeamService: TeamService,
        protected UserService: UserService,
        protected store: Store<RootState>
    ) {
        super($scope, SettingsService, LeagueService, TeamService, UserService, store);

        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.store
            .select(getLeague(this.leagueId))
            .pipe(filter(Boolean))
            .subscribe((league: EntryState<League>) => {
                if (!league.entry) {
                    return;
                }

                this.league = LeagueFactory.getLeagueByType(league.entry) as any;
                this.loading = league.loading;

                if (this.$scope.pagination.data && this.$scope.pagination.data.length > 0) {
                    this.setTeamMembers(this.$scope.pagination.data);
                    this.setUsersShortDescriptions(this.$scope.pagination.data);
                }
            });
    }

    protected shouldLoadUsersShortDescriptions(rankings: IRankingEntry[]) {
        return rankings.length > 0 && !rankings[0].isTeam() && this.league && this.league.getState() === LeagueState.FINISHED;
    }

    protected shouldLoadTeamMembers(rankings: IRankingEntry[]) {
        return rankings.length > 0 && rankings[0].isTeam() && this.league && this.league.getState() === LeagueState.FINISHED;
    }

    public isKnockedOut(rank: RankingEntry) {
        if (typeof this.league === "undefined") {
            return false;
        }

        if (rank.getRawData().away) {
            return true;
        }

        return this.league.getMaxLosses() > 0 && this.league.getMaxLosses() <= rank.getStats().getLosses();
    }
}
